import { env } from '../configs/EnvironmentConfig';

// import { env } from '../configs/EnvironmentConfig';

export const serverAssets = env.API_IMAGE_BASE_URL+'assets/app_Images'
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const API_IMAGE_BASE_URL = env.API_IMAGE_BASE_URL;
export const LOGO_IMAGE = env.API_IMAGE_BASE_URL+"assets/adani_fe_application_logo/finallogo-oneconnect.png";
export const ACCESS_KEY = 'access_token'
export const REFRESH_KEY = 'refresh_token'

export const IMAGE_BASE_URL = env.API_IMAGE_BASE_URL;
export const localPersona = {
    TSE: 'TSE',
    Dealer: 'Dealer',
    Contractor: 'Contractor',
    Engineer: 'Engineer',
    Architect: 'Architect',
    InteriorDesigner: 'Interior Designer',
    Retailer: 'Retailer',
    ARS: 'ARS',
    Bog: 'BOG'
  };
export const ACC_COLOR_PALATE = ['#DA1D1F', '#9D2829'];
export const AMBUJA_COLOR_PALATE = ['#0A3C69', '#425551'];
export const DARPAN_COLOR_PALATE = ['#FFB402', '#FFE230'];
export const ADANI_COLOR_PALATE = ['#75479C', '#BD3861'];
export const ADANI_TRI_COLOR_PALATE = ['#0B74B0', '#75479C', '#BD3861'];

